// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// 第三方包
import axios from "axios";
import "normalize.css";
import "./css/index.css";
import Vuejsonp from "vue-jsonp";
import 'babel-polyfill';
import changeTitle from "./js/changeTitle";


Vue.use(Vuejsonp);
Vue.use(ElementUI);

// 3.2 统一添加配置
axios.defaults.baseURL = process.env.BASE_URL;
// 一配置, 以后所有的请求就会自动使用这个域名
// axios.defaults.withCredentials = true;
// 浏览器有个安全机制, 如果是跨域请求, 浏览器是不会把本地cookie信息携带过去的

// 3.3 统一扩展Vue原型
Vue.prototype.$http = axios;
Vue.prototype.$store = store;
Vue.prototype.$imgDomain = process.env.BASE_URL_IMAGE;
Vue.prototype.$changeTitle = changeTitle;

/* 路由发生变化修改页面title */
// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   next()
// })npm

Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js